<template>
  <b-modal
    :no-close-on-backdrop="true"
    id="exchange_rate_modal"
    size="md"
    body-class="bg-white"
    cancel-title="Cancel"
    cancel-variant="light"
    :ok-title-html="(submitted == true ? loaderIcon : '') + 'Add'"
    :title="'Add Exchange Rate - ' + currency_code"
    ref="exchange_rate_modal"
    @ok.prevent="onSubmit"
    :ok-disabled="submitted"
  >
    <div class="container-fluid">
      <b-alert
        class="alert-transparent alert-danger"
        :show="(error_show && errors.any()) || error_msg"
      >
        <button
          type="button"
          @click="
            error_show = !error_show;
            error_msg = !error_msg;
          "
          class="close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
        <p v-for="item in errors.items" :key="item.id" class="fw-semi-bold">
          {{
          item.field == "Exchange rate" && item.rule == "min_value"
          ? "Exchange rate must be greater than zero."
          : item.msg
          }}
        </p>
        <!-- <p class="fw-semi-bold" v-if="error_msg">{{ message }}</p> -->
      </b-alert>
    </div>
    <b-form>
      <b-row class="mx-0">
        <b-col>
          <b-form-group label="Date" label-for="label-name" label-class="required">
            <DatePicker
              :format="$AppDetails.organization.date_format"
              lang="en"
              input-class="form-control"
              @change="selectDate($event, 'date')"
              style="width: 100% !important"
              data-vv-name="Date"
              name="Date"
              v-model="exchange_rate.date"
              placeholder=" "
              v-validate="'required'"
            >
              <i class="fa fa-calendar text-dark" slot="calendar-icon" />
            </DatePicker>
          </b-form-group>
          <b-form-group
            :label="'Exchange Rate(in ' + orgCurrency + ')'"
            label-for="label-name"
            label-class="required"
          >
            <b-input
              data-vv-name="Exchange rate"
              name="Exchange rate"
              v-model="exchange_rate.value"
              v-validate="'required|max:14|decimal:6|min_value:0.000001'"
            ></b-input>
          </b-form-group>
        </b-col>
      </b-row>
    </b-form>
  </b-modal>
</template>
<script>
import DatePicker from "vue2-datepicker"; // vue datepicker
import { formatDate } from "@/mixins/formatDate";
import { notificationMixin } from "@/mixins/notification"; // global function for calling notification
import { mapGetters, mapState } from "vuex";

export default {
  mixins: [notificationMixin, formatDate], //call the global mixin function

  props: ["exchange_rate", "currency_code"],
  components: { DatePicker },

  data() {
    return {
      loaderIcon: `<i class="fa fa-circle-o-notch fa-spin mr-2"></i>`,
      error_msg: false,
      error_show: false,
      submitted: false
    };
  },
  methods: {
    //  change the due date based on the payment in the customer master data and selected invoice date
    selectDate(val, field) {
      this.exchange_rate[field] =
        val == "" || typeof val == "undefined" || val == null
          ? ""
          : this.formatDate(val);
      this.$store
        .dispatch("currency/fetchExchangeRate", {
          id: this.exchange_rate.currency_id,
          date: this.exchange_rate[field]
        })
        .then(() => {
          this.exchange_rate.value = this.exchange_rate_value.data;
        });
    },
    // create exchange rate function
    async onSubmit() {
      await this.$validator.validateAll().then(result => {
        if (result) {
          this.submitted = true;
          this.error_show = false;

          var data = JSON.stringify(this.exchange_rate);

          this.$store.dispatch("currency/addExchangeRate", data).then(() => {
            this.submitted = false;
            if (this.type == "success") {
              this.error_msg = false;
              //to show the alert message for success or error after api call
              window.Messenger().post({
                extraClasses:
                  "messenger-fixed messenger-on-top messenger-on-center",
                message: this.message,
                type: this.type,
                showCloseButton: true
              });

              this.$refs.exchange_rate_modal.hide();
              this.$emit("success");
            } else {
              this.error_msg = true;
            }
          });
        } else {
          this.error_show = true;
        }
      });
    }
  },
  computed: {
    ...mapState({
      message: state => state.currency.message,
      type: state => state.currency.type,
      exchange_rate_value: state => state.currency.exchange_rate_value
    }),
    ...mapGetters(["orgCurrency"])
  }
};
</script>